"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculationSettings1099Toggle = exports.CollaboratorVerificationStrategy = exports.VerificationStatus = exports.FundingSourceType = exports.PayrollWorkflowStrategy = exports.DocumentType = exports.DocumentStatus = exports.DocumentReasonCode = exports.DepositProduct = exports.PayableSubmissionStrategy = exports.CardBrand = void 0;
var CardBrand;
(function (CardBrand) {
    CardBrand["AmericanExpress"] = "AmericanExpress";
    CardBrand["Visa"] = "Visa";
    CardBrand["Mastercard"] = "Mastercard";
    CardBrand["Discover"] = "Discover";
    CardBrand["DinersClub"] = "DinersClub";
    CardBrand["JCB"] = "JCB";
})(CardBrand = exports.CardBrand || (exports.CardBrand = {}));
var PayableSubmissionStrategy;
(function (PayableSubmissionStrategy) {
    PayableSubmissionStrategy["Allow"] = "Allow";
    PayableSubmissionStrategy["Restrict"] = "Restrict";
    PayableSubmissionStrategy["Decline"] = "Decline";
})(PayableSubmissionStrategy = exports.PayableSubmissionStrategy || (exports.PayableSubmissionStrategy = {}));
var DepositProduct;
(function (DepositProduct) {
    DepositProduct["Member1"] = "Member1";
    DepositProduct["Member2"] = "Member2";
    DepositProduct["Member3"] = "Member3";
    DepositProduct["Enterprise1"] = "Enterprise1";
    DepositProduct["Enterprise2"] = "Enterprise2";
    DepositProduct["Enterprise3"] = "Enterprise3";
})(DepositProduct = exports.DepositProduct || (exports.DepositProduct = {}));
var DocumentReasonCode;
(function (DocumentReasonCode) {
    DocumentReasonCode["PoorQuality"] = "PoorQuality";
    DocumentReasonCode["NameMismatch"] = "NameMismatch";
    DocumentReasonCode["SSNMismatch"] = "SSNMismatch";
    DocumentReasonCode["AddressMismatch"] = "AddressMismatch";
    DocumentReasonCode["DOBMismatch"] = "DOBMismatch";
    DocumentReasonCode["ExpiredId"] = "ExpiredId";
    DocumentReasonCode["EINMismatch"] = "EINMismatch";
    DocumentReasonCode["StateMismatch"] = "StateMismatch";
    DocumentReasonCode["Other"] = "Other";
})(DocumentReasonCode = exports.DocumentReasonCode || (exports.DocumentReasonCode = {}));
var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["Required"] = "Required";
    DocumentStatus["Approved"] = "Approved";
    DocumentStatus["Invalid"] = "Invalid";
    DocumentStatus["ReceivedFront"] = "ReceivedFront";
    DocumentStatus["ReceivedBack"] = "ReceivedBack";
    DocumentStatus["PendingReview"] = "PendingReview";
})(DocumentStatus = exports.DocumentStatus || (exports.DocumentStatus = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType["IdDocument"] = "IdDocument";
    DocumentType["Passport"] = "Passport";
    DocumentType["AddressVerification"] = "AddressVerification";
    DocumentType["SocialSecurityCard"] = "SocialSecurityCard";
    DocumentType["CertificateOfIncorporation"] = "CertificateOfIncorporation";
    DocumentType["EmployerIdentificationNumberConfirmation"] = "EmployerIdentificationNumberConfirmation";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
var PayrollWorkflowStrategy;
(function (PayrollWorkflowStrategy) {
    PayrollWorkflowStrategy["SingleStage"] = "SingleStage";
    PayrollWorkflowStrategy["DualStage"] = "DualStage";
})(PayrollWorkflowStrategy = exports.PayrollWorkflowStrategy || (exports.PayrollWorkflowStrategy = {}));
var FundingSourceType;
(function (FundingSourceType) {
    FundingSourceType["InternalAccount"] = "InternalAccount";
    FundingSourceType["Account"] = "Account";
    FundingSourceType["PaymentCard"] = "PaymentCard";
})(FundingSourceType = exports.FundingSourceType || (exports.FundingSourceType = {}));
var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["None"] = "None";
    VerificationStatus["Pending"] = "Pending";
    VerificationStatus["Failed"] = "Failed";
    VerificationStatus["Verified"] = "Verified";
})(VerificationStatus = exports.VerificationStatus || (exports.VerificationStatus = {}));
var CollaboratorVerificationStrategy;
(function (CollaboratorVerificationStrategy) {
    CollaboratorVerificationStrategy["None"] = "None";
    CollaboratorVerificationStrategy["TaxDocumentation"] = "TaxDocumentation";
    CollaboratorVerificationStrategy["KnowYourCustomer"] = "KnowYourCustomer";
})(CollaboratorVerificationStrategy = exports.CollaboratorVerificationStrategy || (exports.CollaboratorVerificationStrategy = {}));
var CalculationSettings1099Toggle;
(function (CalculationSettings1099Toggle) {
    CalculationSettings1099Toggle["Include"] = "Include";
    CalculationSettings1099Toggle["Exclude"] = "Exclude";
})(CalculationSettings1099Toggle = exports.CalculationSettings1099Toggle || (exports.CalculationSettings1099Toggle = {}));
//# sourceMappingURL=paymentSettings.js.map